(ns quuppa.qmd.map-utils)

(def PI #?(:cljs js/Math.PI
           :clj Math/PI))

(defn cos [rad]
  #?(:cljs (js/Math.cos rad)
     :clj (Math/cos rad)))

(defn sin [rad]
  #?(:cljs (js/Math.sin rad)
     :clj (Math/sin rad)))

(defn atan2 [x y]
  #?(:cljs (js/Math.atan2 x y)
     :clj (Math/atan2 x y)))

(defn rad->deg [rad]
  (* (/ 180 PI) rad))

(defn deg->rad [deg]
  (* (/ PI 180) deg))

(defn rotate-bg [rect rotation]
  (let [rad (deg->rad rotation)
        ;; x,y is bg image bottom left corner
        ;; x+width,y+width is top right
        {:keys [x y width height]} rect
        c (cos rad)
        s (sin rad)
        ;; Rotate both points
        x1 (+ (* c x) (* s y))
        x2 (+ (* c (+ x width)) (* s (+ y height)))
        y1 (- (* c y) (* s x))
        y2 (- (* c (+ y height)) (* s (+ x width)))]
    ;; Find new corners after the rotation.
    {:min-x (min x1 x2)
     :min-y (min y1 y2)
     :max-x (max x1 x2)
     :max-y (max y1 y2)}))

(defn get-svg-bounding-box
  "We want to map image to display all tracking areas (= CS bounding-box)
  and also show all the background images.

  Background image coordinates are pre-rotation, so we need to rotate
  those coordinates first."
  [{:keys [background-images bounding-box locators] :as _cs}]
  (let [{bb-x :x, bb-y :y, bb-width :width, bb-height :height} bounding-box

        [min-x min-y max-x max-y]
        (as-> [bb-x
               bb-y
               (+ bb-x bb-width)
               (+ bb-y bb-height)]
              $
              (reduce (fn [[min-x min-y max-x max-y] {:keys [rect rotation]}]
                        ;; Seems like we want to rotate reverse direction.
                        (let [rotated (rotate-bg rect (- rotation))]
                          [(min min-x (:min-x rotated))
                           (min min-y (:min-y rotated))
                           (max max-x (:max-x rotated))
                           (max max-y (:max-y rotated))]))
                      $
                      (vals background-images))
              ;; Also go through locators, in case some locator coordinates are
              ;; outside of the CS bb or bgs.
              (reduce (fn [[min-x min-y max-x max-y] locator]
                        [(min min-x (:x (:converted-location locator)))
                         (min min-y (:y (:converted-location locator)))
                         (max max-x (:x (:converted-location locator)))
                         (max max-y (:y (:converted-location locator)))])
                      $
                      (vals locators)))

        width (- max-x min-x)
        height (- max-y min-y)]
    {:x min-x
     :y min-y
     :width width
     :height height}))

(defn extend-bounding-box [{:keys [x y width height]}]
  ;; Add 25% around edges
  {:x (- x (* 0.25 width))
   :y (- y (* 0.25 height))
   :width (* 1.5 width)
   :height (* 1.5 height)})

(defn normalize-angle [angle]
  (Math/atan2 (Math/sin angle) (Math/cos angle)))

(defn get-azimuth
  "Return Quuppa Locator azimuth,
  zero is at three a'clock and going counterclockwise."
  [direction [locator-x locator-y] [user-x user-y]]
  (let [raw-azimuth (atan2 (- locator-x user-x)
                           (- locator-y user-y))
        azimuth (- (+ (case direction
                        :top (deg->rad 90) ;; 3 a'clock
                        :bottom (deg->rad 270)
                        :left (deg->rad 180)
                        :right 0
                        0)
                      raw-azimuth))]
    (normalize-angle azimuth)))

(defn quuppa-rad->css-deg
  "Quuppa Locator azimuth is starting from 3 a'clock (90deg)
  and going counterclockwise."
  [rad]
  (+ 90
     (- (rad->deg rad))))
